import { render, staticRenderFns } from "./oilType.vue?vue&type=template&id=276ca7a6&"
import script from "./oilType.vue?vue&type=script&lang=js&"
export * from "./oilType.vue?vue&type=script&lang=js&"
import style0 from "./oilType.vue?vue&type=style&index=0&id=276ca7a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports